export default __webpack_public_path__ + "static/media/chat_bot_image8.50b557a3.jpg";